"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var AccessKeySinkContext = /*#__PURE__*/(0, _react.createContext)();
var _default = AccessKeySinkContext;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJBY2Nlc3NLZXlTaW5rQ29udGV4dCIsImNyZWF0ZUNvbnRleHQiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9VdGlscy9BY2Nlc3NLZXlTaW5rL2ludGVybmFsL0NvbnRleHQuanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3JlYXRlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcblxuY29uc3QgQWNjZXNzS2V5U2lua0NvbnRleHQgPSBjcmVhdGVDb250ZXh0KCk7XG5cbmV4cG9ydCBkZWZhdWx0IEFjY2Vzc0tleVNpbmtDb250ZXh0O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUEsSUFBTUEsb0JBQW9CLGdCQUFHLElBQUFDLG9CQUFBLEdBQTdCO2VBRWVELG9CIn0=